import { render, staticRenderFns } from "./acountForm.vue?vue&type=template&id=2ba4d647&scoped=true&"
import script from "./acountForm.vue?vue&type=script&lang=js&"
export * from "./acountForm.vue?vue&type=script&lang=js&"
import style0 from "./acountForm.vue?vue&type=style&index=0&id=2ba4d647&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4d647",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba4d647')) {
      api.createRecord('2ba4d647', component.options)
    } else {
      api.reload('2ba4d647', component.options)
    }
    module.hot.accept("./acountForm.vue?vue&type=template&id=2ba4d647&scoped=true&", function () {
      api.rerender('2ba4d647', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_acount/form/acountForm.vue"
export default component.exports